import React, { useEffect, useRef, useState } from 'react'

const MonumentProjectWidget = ({activeWidget,view}) => {
  const monProjectWidgetDiv = useRef(null);
  const [visible, setVisible] = useState(false)

  useEffect(() => {
      if (activeWidget === "monumentProject") {
        setVisible(true);
      } else {
        setVisible(false);
      }
    }, [activeWidget]);
  


  let style = { display: "initial" };
  if (visible) {
    style.display = "initial";
  } else {
    style.display = "none";
  }
  
  return(

  <div ref={monProjectWidgetDiv} style={style}>
    <div>this is the project widget</div>
  </div>

  ) 
}

export default MonumentProjectWidget